var _style, _circle, _path, _polygon, _path2, _path3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 38.1 38.1",
    viewBox: "0 0 38.1 38.1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#D4DE67;} .st1{fill:#D4DE67;} .st2{clip-path:url(#SVGID_2_);} .st3{fill:#DCDBDB;} .st4{fill:#FFFFFF;} .st5{fill:#F2F2F2;} .st6{clip-path:url(#SVGID_4_);} .st7{fill:none;} .st8{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;} .st9{clip-path:url(#SVGID_6_);} .st10{clip-path:url(#SVGID_8_);} .st11{clip-path:url(#SVGID_10_);}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 19.1,
    cy: 19.1,
    r: 18.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.1,38C8.7,38,0.3,29.5,0.3,19.1S8.7,0.3,19.1,0.3"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "7.7 23.9 21.1 11.1 24.9 15 11.5 27.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m27.3 12.6c-0.1-0.1-3.8-3.9-3.8-3.9s2.7-2.6 2.9-2.8c0.5-0.4 1.2-0.3 1.7 0.1 0.2 0 1.9 1.8 2.1 2 0.5 0.5 0.4 1.4-0.1 1.9-0.4 0.4-2.5 2.4-2.8 2.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m7.1 24.6s3.8 3.9 3.8 3.9c-0.6 0.1-5 1-5 1s1.2-4.9 1.2-4.9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    transform: "matrix(-.7213 .6926 -.6926 -.7213 49.874 3.6121)",
    x: 23.6,
    y: 9.1,
    width: 1.2,
    height: 5.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.f874dbfebef803b8e56915cd0838ab61.svg";
export { ForwardRef as ReactComponent };